import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { SupabaseService } from '../service/supabase.service';
import { DBUser } from '../interface/user.interface';


export const userResolver: ResolveFn<DBUser | null> = async (route, state) => {
  
  const supabaseService = inject(SupabaseService);
  const router = inject(Router);

  const currentUser = await supabaseService.getUser();
  //console.log("From Resolver",currentUser);
  
  if(!currentUser) {
    router.navigate(['/onboard'])
    return null;
  }
  return currentUser;
};
